import React from 'react'
import PropTypes from 'prop-types'
import exact from 'prop-types-exact'
import classnames from 'classnames'

import AiLabel from 'components/AiLabel'

const Page = ({
  children,
  width,
  height,
  page,
  isSelected,
  isSelectable = true,
  showBleed,
  aiLabel = null,
  ...rest
}) => {
  const hasElements = Object.keys(page.elements).length

  return (
    <div
      className={classnames({
        Page: true,
        'Page--is-selectable': isSelectable,
        'Page--empty': !hasElements,
        'Page--active': isSelected,
        'Page--show-bleed': showBleed,
      })}
      style={{ width, height }}
      data-page-id={page.id}
      {...rest}
    >
      {children}
      {aiLabel && (
        <AiLabel aiLabel={aiLabel} pageWidth={width} pageHeight={height} />
      )}
      {showBleed && <div className="Page__bleed-outline" />}
    </div>
  )
}

Page.propTypes = exact({
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  page: PropTypes.object.isRequired,
  isSelected: PropTypes.bool.isRequired,
  showBleed: PropTypes.bool,
  isSelectable: PropTypes.bool,
  aiLabel: PropTypes.shape({
    variant: PropTypes.string.isRequired,
    position: PropTypes.string.isRequired,
  }),
  onClick: PropTypes.func,
  onMouseDownCapture: PropTypes.func,
  onScroll: PropTypes.func,
})

export default Page
